var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 104,
    viewBox: "0 0 168 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.6 18L113.1 18.1L113 17.2L114.5 17.1C114.7 17.1 114.9 17.3 114.9 17.5C115.1 17.8 114.9 18 114.6 18Z",
    fill: "#0ABAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.7 20.8L113.2 20.7L113.1 21.6L114.6 21.7C114.8 21.7 115 21.5 115 21.3C115.1 21 114.9 20.8 114.7 20.8Z",
    fill: "#0ABAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.7 23.9L114.9 20.4C115.4 20.4 119 20.1 118.9 19.4C118.9 18.4 114.9 18.4 114.9 18.4L111.7 14.9C111.5 14.8 111.4 14.8 111.3 14.9C111.2 15 111.3 15.4 111.6 16.1C112.1 16.9 112.5 17.7 113 18.5L109.7 18.7L108 17.7L107.7 18.1L108.2 18.9C107.6 19 107.2 19.3 107.2 19.4C107.2 19.6 107.6 19.8 108.2 19.9L107.7 20.8L108 21.1L109.8 20C110.9 20.1 111.9 20.2 113 20.2C112.5 21 112.1 21.8 111.6 22.6C111.2 23.3 111.1 23.7 111.3 23.8C111.4 24 111.5 24 111.7 23.9Z",
    fill: "#0ABAB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.7 14.9C111.5 14.8 111.4 14.8 111.3 14.9C111.2 15 111.3 15.4 111.6 16.1C111.6 16.2 111.7 16.2 111.7 16.3L113 16.4L111.7 14.9Z",
    fill: "#0ABAB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.7 23.9C111.5 24 111.4 24 111.3 23.9C111.2 23.8 111.3 23.4 111.6 22.7C111.6 22.6 111.7 22.6 111.7 22.5L113 22.4L111.7 23.9Z",
    fill: "#0ABAB5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.8 58.3H128.5C130.9 58.3 132.8 60.3 132.8 62.7V81.1H114.2C111.8 81.1 108.7 79.9 108.7 77.5V70.1C108.7 67.3 110.5 66.7 113.6 66.7H125.3V65.5C125.3 64.8 124.8 64.3 124.1 64.3H109.8V58.3ZM116.5 71.3H125.4V74.1H116.5C116 74.1 115.5 73.7 115.5 73.1V72.3C115.6 71.8 116 71.3 116.5 71.3Z",
    fill: "#0ABAB5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1 58.3H19.8C22.2 58.3 24.1 60.3 24.1 62.7V81.1H5.5C3.1 81.2 0 80 0 77.6V70.2C0 67.4 1.8 66.8 4.9 66.8H16.6V65.6C16.6 64.9 16.1 64.4 15.4 64.4H1.1V58.3ZM7.9 71.3H16.8V74.1H7.9C7.4 74.1 6.9 73.7 6.9 73.1V72.3C6.9 71.8 7.3 71.3 7.9 71.3Z",
    fill: "#0ABAB5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2 58H74.4C76.5 58 78.5 59.2 78.5 61.3V69.8C78.5 71.9 76.8 72.7 74.7 72.7H61.7V81.1H54V72.7V70.3V58H54.2ZM61.8 64.4H71C71.6 64.4 72.1 64.9 72.1 65.5V65.7C72.1 66.3 71.6 66.8 71 66.8H61.8V64.4Z",
    fill: "#0ABAB5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8999 74.4H74.0999L79.1999 81.2H70.0999L64.8999 74.4Z",
    fill: "#EC1C24"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3999 58H88.0999V66.2H99.2999V58H106V77C106 79.3 104.2 81.1 101.9 81.1H82.7999V75.2H96.9999C97.5999 75.2 98.0999 74.7 98.0999 74.1V72.7H86.4999C83.8999 72.7 81.3999 72.5 81.3999 69.9V58Z",
    fill: "#0ABAB5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.7 58.2H156.1C159.1 58.2 161.6 60.7 161.6 63.8V81.2H153.7V67C153.7 66 152.9 65.3 152 65.3H143.8V81.3H135.6V58.2H135.7Z",
    fill: "#0ABAB5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1 58.3H46.8C49.2 58.3 51.1 60.3 51.1 62.7V81.1H32.5C30.1 81.1 27 79.9 27 77.5V70.1C27 67.3 28.8 66.7 31.9 66.7H43.6V65.5C43.6 64.8 43.1 64.3 42.4 64.3H28.1V58.3ZM34.9 71.3H43.8V74.1H34.9C34.4 74.1 33.9 73.7 33.9 73.1V72.3C33.9 71.8 34.3 71.3 34.9 71.3Z",
    fill: "#0ABAB5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3997 26.2C94.3997 27.7 90.7997 29.8 87.1997 32.4C90.0997 41.1 92.9997 49.5 93.0997 49.8H105.9L97.3997 26.2ZM87.8997 0H73.7997L59.1997 40.5C60.9997 38.2 63.1997 35.7 65.9997 33.2C68.8997 30.6 72.3997 27.8 76.7997 25.3C78.9997 18.7 80.7997 13.4 80.7997 13.4C80.7997 13.4 81.9997 17 83.6997 22C86.9997 20.6 90.6997 19.5 94.6997 18.8L87.8997 0Z",
    fill: "#2CBBB5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 20.1C105.1 20.3 80.3998 27.9 68.4998 49.8H55.7998C55.7998 49.8 70.3998 20.1 105.9 20.1Z",
    fill: "#2CBBB5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 20.1C105.1 20.3 80.3997 27.9 68.4997 49.8H62.1997C64.2997 45.7 68.7997 38.9 77.3997 32.1C90.6997 21.7 105.3 20.2 105.9 20.1Z",
    fill: "#EC1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.609525290d9882157bbb2f254cf62723.svg";
export { ForwardRef as ReactComponent };